import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=0220fb7a"
import script from "./Show.js?vue&type=script&lang=js&external"
export * from "./Show.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports